import { render, staticRenderFns } from "./PgaDeliverableCreate.vue?vue&type=template&id=4d28f2b8&"
import script from "./PgaDeliverableCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaDeliverableCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d28f2b8')) {
      api.createRecord('4d28f2b8', component.options)
    } else {
      api.reload('4d28f2b8', component.options)
    }
    module.hot.accept("./PgaDeliverableCreate.vue?vue&type=template&id=4d28f2b8&", function () {
      api.rerender('4d28f2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/components/create/sub-components/PgaDeliverableCreate.vue"
export default component.exports